import { useEffect, useState } from 'react';
import GenericDataTable from './GenericDataTable';
import ShipmentUpdateHistoryTableRowFormatter from './ShipmentUpdateHistoryTableRowFormatter';
import { ShipmentUpdateModel } from '../apiModels/shipmentUpdateModel';
import { toast } from 'react-toastify';
import { logError } from '../utilities';
import { getShipmentUpdates } from '../api/shipmentUpdateApi';

export default function ShipmentUpdateHistoryTable(props: {
    shipmentTrackingNumber: string,
    reloadShipment: () => void,
    canEdit: boolean,
}) {
    const notifyUserOfError = (err: string) => toast(err, { type: 'error' });
    const [isTableLoading, setIsTableLoading] = useState(true);
    const [shipmentUpdates, setShipmentUpdates] = useState<ShipmentUpdateModel[]>([]);

    const loadUpdateHistory = async (trackingNumber: string) => {
        setIsTableLoading(true);

        try {
            let updates = await getShipmentUpdates(trackingNumber);
            setShipmentUpdates(updates);
            setIsTableLoading(false);
        }
        catch (error: any) {
            if (error instanceof Error) {
                notifyUserOfError(error.message);
            }

            logError(error);
            setIsTableLoading(false);
        }
    };

    useEffect(() => {
        loadUpdateHistory(props.shipmentTrackingNumber);
    }, [props.shipmentTrackingNumber]);

    return (
        <GenericDataTable data={shipmentUpdates}
            dataFormatter={(data) => <>{data.map((d) => <ShipmentUpdateHistoryTableRowFormatter key={d.shipmentUpdateId}
                shipmentUpdate={d}
                reloadShipment={props.reloadShipment}
                canEdit={props.canEdit} />)}</>}
            noDataMessage='There is no shipment update history available.'
            columnCount={5}
            isLoading={isTableLoading}>
            <tr>
                <td></td>
                <td>Tracking Number</td>
                <td>Description</td>
                <td>Location</td>
                <td>Status</td>
                <td>Date/Time</td>
            </tr>
        </GenericDataTable>
    );
}